import { defineMessages } from 'react-intl';

export default defineMessages({
  defaultHeader: {
    id: 'errorPage.defaultHeader',
    defaultMessage: 'Something went wrong.',
  },
  defaultMessage: {
    id: 'errorPage.defaultMessage',
    defaultMessage: 'Please try again. If the problem persists, please contact the Event Host.',
  },
});
